import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, TextField } from "components";
import Label from "egov-ui-kit/utils/translationNode";
import { ProfileSection } from "modules/common";
import { httpRequest } from "../../../../../../ui-utils/api.js";

import "./index.css";

const ProfileForm = ({ form, handleFieldChange, onClickAddPic, img, profilePic, localProfilePreview, userInfo }) => {
  const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
  // const [getPhoto, setGetPhoto] = useState(null);
  useEffect(() => {
    const fetchPhoto = async () => {
      try {
        const tenantId = userInfo.tenantId;
        const uuid = userInfo.uuid;
        if (!uuid || !tenantId) return;

        const userPayload = await httpRequest("post", "/user/_search", "_search", [], {
          tenantId,
          uuid: [uuid],
        });

        const photoId = userPayload.user[0].photo;

        if (!photoId) return;
        const storedUserInfo = localStorage.getItem("user-info");
        if (storedUserInfo) {
          const parsedUserInfo = JSON.parse(storedUserInfo);
          parsedUserInfo.photo = photoId; // Add or update `photo` field
          localStorage.setItem("user-info", JSON.stringify(parsedUserInfo)); // Save back
        }

        const fileResponse = await httpRequest("get", "/filestore/v1/files/url", "", [
          { key: "tenantId", value: "up" },
          { key: "fileStoreIds", value: photoId },
        ]);

        // const url = fileResponse.fileStoreIds[0].url;
        const url = photoId;
        if (url) {
          setProfilePhotoUrl(url);
        }
      } catch (error) {
        console.error("Error fetching user photo:", error);
      }
    };

    fetchPhoto();
  }, [userInfo]);

  const fields = form.fields || {};
  const submit = form.submit;

  // useEffect(()=>{

  // },[])

  return (
    <div>
      <div className="profile-card-container">
        <div style={{ display: "flex" }}>
          <div style={{ padding: 0 }} className="col-xs-12 col-sm-4 col-md-4 col-lg-4 profile-profilesection">
            {/* <ProfileSection img={profilePic || img} onClickAddPic={onClickAddPic} /> */}

            <ProfileSection img={localProfilePreview || profilePhotoUrl || profilePic || img} onClickAddPic={onClickAddPic} />
          </div>
          <div style={{ padding: "0 8px" }} className="col-xs-12 col-sm-8 col-md-8 col-lg-8 profileFormContainer">
            <TextField {...fields.name} onChange={(e, value) => handleFieldChange("name", value)} />
            <TextField
              {...fields.phonenumber}
              maxlength={10}
              type="number"
              onChange={(e, value) => {
                const trimmedValue = value.toString().slice(0, 10);
                handleFieldChange("phonenumber", trimmedValue);
              }}
              // onChange={(e, value) => handleFieldChange("phonenumber", value)}
            />
            <TextField {...fields.email} onChange={(e, value) => handleFieldChange("email", value)} />
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Button className="responsive-action-button" {...submit} primary={true} fullWidth={true} />
              <Link to="/user/change-password">
                <div style={{ marginTop: "24px", marginBottom: "24px" }}>
                  <Label className="change-password-label-style" label={"Change Password"} color="#f89a3f" />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="responsive-action-button-cont">
        <Button className="responsive-action-button" {...submit} primary={true} fullWidth={true} />
      </div> */}
    </div>
  );
};

export default ProfileForm;



// WEBPACK FOOTER //
// src/modules/employee/User/Profile/components/ProfileForm/index.js